/****
 * 报表相关接口
 */
import axios from 'axios';

// 未结明细
export const unsettle = () => {
  return axios.get('/ssc_golang/v1/report/unsettle?random='+new Date().getTime());
};

// 未结明细详情
export const unsettle2 = lottery_type => {
  return axios.get('/ssc_golang/v1/report/unsettle2?random='+new Date().getTime(), {params: {lottery_type}});
};


// 历史报表
export const history = (lottery_type) => {
  return axios.get('/ssc_golang/v1/report/history?random='+new Date().getTime(), {params: {lottery_type}});
};

// 今日已结
export const history2 = (date = '',lottery_type=0) => {
  return axios.get('/ssc_golang/v1/report/history2?random='+new Date().getTime(), {params: {date, lottery_type}});
};


export const history3 = ({date, lottery_type}) => {
  return axios.get('/ssc_golang/v1/report/history3?random='+new Date().getTime(), {params: {date, lottery_type}});
};

export const history4 = ({period,lottery_type}) => {
  return axios.get('/ssc_golang/v1/report/history4?random='+new Date().getTime(), {params: {period, lottery_type}});
};



// WEBPACK FOOTER //
// ./src/service/report.js